import React, { useEffect, useState } from "react";

const RequestQA = (props) => {
    const [menuData, setMenuData] = useState([]);
    const [subData, setSubData] = useState([]);
    const [openPath, setOpenPath] = useState(false);
    const [openType, setOpenType] = useState(false);
    const [openSub, setOpenSub] = useState(false);
    const [pathData, setPathData] = useState(null)
    const [categoryList, setCategoryList] = useState([]);
    const [data, setData] = useState({});

    useEffect(() => {
        getMenuData();
    }, []);

    useEffect(() => {
        if(!openPath) setSubData([]);
    }, [openPath]);

    useEffect(() => {
        const tree = document.querySelector(".path-tree");
        tree?.scrollTo({top: 0, behavior: 'smooth'});
    }, [subData]);
    
    useEffect(() => {
        setData(prev => { return {...prev, path: pathData ?? prev.path, type: null, sub: ''}});
    }, [pathData]);

    useEffect(() => {
        if (openType) getCategory();
    }, [openType]);

    const getMenuData = () => {
        const fetchMenuData = async () => {
            try {
                const response = await fetch('datas/menu/menu.json', {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json; charset=utf-8',
                        'Cache-Control': 'no-cache'
                    }
                });
                const data = await response.json();
                setMenuData(data.filter(x => x.hasSub && x.visible !== false));
            } catch (error) {
                console.error("Failed to fetch menu data", error);
            }
        };
        fetchMenuData();
    }

    const fetchDocumentMenu = (className) => {
        fetch(`datas/menu/${className}.json`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        })
            .then((response) => {
                if (!response.ok) {
                    setSubData([]);
                    return null;
                }
                return response.json();
            })
            .then((data) => {
                if (data && data.children?.length > 0) {
                    setSubData(data);
                } else {
                    setSubData([]);
                    setOpenPath(false);
                }
            })
            .catch((error) => {
                console.error("문서 읽기 오류:", error);
                setSubData([]);
            });
    };

    const getCategory = (group = "product") => {
        fetch('datas/oper/categorytype.json',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache'
                }
            }).then((resp) => resp.json()).then(data => {
                setCategoryList(data);
            }).catch(e => {
            });
    };

    const onSubmit = (e) => {
        props.onSubmit('Request', data);
    };

    const onClose = () => {
        props.onClose();
    };

    const handleChange = (e) => {
        let value = e.target.value;
        setData(prev => {return {...prev, [e.target.name]: value}});
    }

    const onClickNode = (e, data) => {
        const path = getPath(data, subData);
        setPathData(prev => { return {...prev, fullPath: path}});
        setOpenPath(false);
    }

    const changeCollapse = (e, data, type="sub") => {
        e.preventDefault();
        e.stopPropagation();
        const button = e.currentTarget;
        const ul = button.closest('li').querySelector('ul');
        if (data.collapsed) {
            ul.style.display = 'block';
            data.collapsed = false;
        } else {
            ul.style.display = 'none';
            data.collapsed = true;
        }
        if (type === "sub") {
            const updateCollapse = (children) => {
                for (const child of children) {
                    if (child.manualId === data.manualId) {
                        child.collapsed = data.collapsed;
                        break;
                    }
                    if (child.children) {
                        updateCollapse(child.children);
                    }
                }
                return [...children];
            }
            setSubData(prev => {return {...prev, children: updateCollapse(subData.children)}});
        } else {
            setMenuData(menuData.map(menu => menu.route === data.route ? {...menu, collapsed: data.collapsed} : menu));
        }
    };

    const handleMenuClick = (main, sub) => {
        setPathData({menuPath: `${main.route}/${sub.route}`, location: `${main.title}/${sub.title}`, fullPath: []});
        fetchDocumentMenu(sub.route);
    }

    const getPathName = (pathData) => {
        const location = pathData.location.split("/");
        const path = [...location, ...pathData.fullPath].filter(Boolean).join(" > ");
        return path.trim();
    }

    const getPath = (node, tree) => {
        // 내부 재귀 함수
        const searchPath = (datas, path) => {
            for (let data of datas) {
                // manualId가 일치하면 경로 반환
                if (data.manualId === node.manualId) {
                    return [...path, data.module];
                }
                // children이 있으면 재귀 탐색
                if (data.children) {
                    const result = searchPath(data.children, [...path, data.module]);
                    if (result) return result; // 경로가 발견되면 반환
                }
            }
            return null; // 탐색 실패 시 null 반환
        };
        // 탐색 시작
        const path = searchPath(tree.children, []) || [];

        // 마지막 요소를 제외한 경로 반환
        return path;
    };

    const renderTree = (data, depth = 0) => (
        <>
            {!data.children && (
                <a className={`depth-${depth} last-depth`}
                    href={() => { }}
                    onClick={e => onClickNode(e, data)}>
                    {data.children && (
                        <div className={`btn-expand ${data.collapsed ? 'collapse' : ''}`}><i className="icoKdc16 expand"></i></div>
                    )}
                    <i className="icoKdc20 document icon-folder"></i>
                    <span className="txt folder">{data.module}</span>
                </a>
            )}
            {data.children && (
                <ul style={{ display: `${data.collapsed ? 'none' : 'block'}`, paddingLeft: (depth * 16)+"px" }}>
                    {data.children.map((child, index) => (
                        <li key={index}>
                            <a className={`depth-${depth} ${!child.children ? 'last-depth' : ''}`}
                                href={() => { }}
                                style={{display: "flex", padding: "8px 5px"}}
                                onClick={e => onClickNode(e, child)}>
                                {child.children && (
                                    <div className={`btn-expand ${child.collapsed ? 'collapse' : ''}`} onClick={(e) => changeCollapse(e, child)}><i className="icoKdc16 expand"></i></div>
                                )}
                                <i className="icoKdc20 document icon-folder"></i>
                                <span className="txt folder">{child.module}</span>
                            </a>
                            {child.children && renderTree(child, depth + 1)}
                        </li>
                    ))}
                </ul>
            )}
        </>
    );

    const wrapperStyle = {
        position: "absolute",
        width: "100%",
        height: "fit-content",
        background: "white", 
        border: "1px solid black",
        borderRadius: "5px",
        zIndex: "99"
    }
    
    const menuPathStyle = { 
        width: "100%", 
        maxHeight: "300px",
        overflowY: "auto",
        padding: "10px 14px"
    };
    const subMenuStyle = {
        paddingLeft: "16px"
    };
    const path = () => {
        return (
            <div className="request-path" style={{ position: "relative"}}>
                <div className="cate-top">
                    <h4 className="cate-title">경로</h4>
                    {/* <span className="require">*</span> */}
                </div>
                <div className="selectbox" onClick={() => setOpenPath(prev => !prev)}>
                    <p>{data.path ? getPathName(data.path) : "선택해주세요."}</p>
                    <button className="btn-dropdown">
                        <i className="icoKdc16 select-dropdown"></i>
                    </button>
                </div>
                {openPath && 
                    (
                        (!subData.children || subData.children?.length === 0) ?
                        <div className="left-ctgr" style={wrapperStyle}>
                            <div className="ctgr-tree" style={{padding:"0"}}>
                                <ul className="tree" style={menuPathStyle}>
                                    {menuData.map(x => {
                                        return (
                                            <li>
                                                <a style={{display: "flex", padding: "8px 5px"}}>
                                                    {x.hasSub && (
                                                        <div className={`btn-expand ${x.collapsed ? 'collapse' : ''}`} onClick={(e) => changeCollapse(e, x, "main")}><i className="icoKdc16 expand"></i></div>
                                                    )}
                                                    <i className="icoKdc20 document icon-folder"></i>
                                                    <span>{x.title}</span>
                                                </a>
                                                {
                                                    x.submenu && x.hasSub ?
                                                        <ul style={subMenuStyle}>
                                                            {x.submenu.map((sub, index) => {
                                                                return (
                                                                    <li key={index} onClick={() => handleMenuClick(x, sub)} style={{ cursor: 'pointer' }}>
                                                                        <a style={{display: "flex", padding: "8px 5px"}}>
                                                                            <i className="icoKdc20 document icon-folder"></i>
                                                                            {sub.title}
                                                                        </a>
                                                                    </li>
                                                                );
                                                            }
                                                            )}
                                                        </ul>
                                                    : null
                                                }
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                        :
                        <div className="left-ctgr" style={wrapperStyle}>
                            <div onClick={() => setSubData([])} style={{display: "flex", padding: "15px 10px 0px", cursor: "pointer"}}>
                                <i className="icoKdc16 expand" style={{transform: "rotate(-90deg)"}}></i>
                            </div>
                            <div className="ctgr-tree" style={{padding:"0"}}>
                                <ul className="tree" style={menuPathStyle}>
                                    <li>
                                        {renderTree(subData)}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    )
                }
            </div>
        )
    }

    const title = () => {
        return (
            <div className="memo">
                <div className="cate-top">
                    <h4 className="cate-title">메뉴명</h4>
                </div>
                <input className="input-memo" type="text" id="name" name="title" placeholder="게시 요청할 메뉴 이름을 입력하세요." onChange={handleChange}/>
            </div>
        )
    }

    const setType = (e, type) => {
        setData(prev => { return {...prev, type: type, sub: ''}});
        setOpenType(false);
    }

    const type = () => {
        return (
            <div className="product" style={{position: "relative"}}>
                <div className='cate-top'>
                    <h4 className="cate-title">제품군 선택</h4>
                </div>
                    <div className="selectbox" onClick={() => setOpenType(prev => !prev)}>
                        <p>{data.type ? `K-System ${data.type.type.charAt(0).toUpperCase() + data.type.type.slice(1)}` : "전체"}</p>
                        <button className="btn-dropdown">
                            <i className="icoKdc16 select-dropdown"></i>
                        </button>
                    </div>
                    {openType && 
                        <div className="left-ctgr" style={wrapperStyle}>
                            <div className="ctgr-tree" style={{padding:"0"}}>
                                <ul className="tree" style={menuPathStyle}>
                                    <li key={-1} onClick={(e) => setType(e)}>
                                        <a style={{padding: "8px 5px"}}>{"전체"}</a>
                                    </li>
                                    {categoryList.map((category, index) => (
                                        <li key={index} onClick={(e) => setType(e, category)}>
                                            <a style={{padding: "8px 5px"}}>{`K-System ${category.type.charAt(0).toUpperCase() + category.type.slice(1)}`}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    }
            </div>
        )
    }

    const setSub = (e, sub) => {
        setData(prev => { return {...prev, sub: sub ?? ''}});
        setOpenSub(false);
    }

    const sub = () => {
        let isVersion = false;
        if (!data.type) return;
        if (data.type.type === "genuine" || data.type.type === "ace") {
            isVersion = true;
        }
        return (
            <div className="version" style={{position: "relative"}}>
                <div className="cate-top">
                    <h4 className="cate-title">{isVersion ? "버전 정보 선택" : "구분 선택"}</h4>
                    {isVersion && <span>제뉴인/에이스에 해당</span>}
                </div>
                <div className="selectbox" onClick={() => setOpenSub(prev => !prev)} style={{margin:"0"}}>
                    <p>{data.sub || "전체"}</p>
                    <button className="btn-dropdown">
                        <i className="icoKdc16 select-dropdown"></i>
                    </button>
                </div>
                {openSub && 
                    <div className="left-ctgr" style={wrapperStyle}>
                        <div className="ctgr-tree" style={{padding:"0"}}>
                            <ul className="tree" style={menuPathStyle}>
                                <li key={-1} onClick={(e) => setSub(e)}>
                                    <a style={{padding: "8px 5px"}}>{"전체"}</a>
                                </li>
                                {categoryList.find(cate => cate.type === data.type?.type)
                                    ?.version?.map((sub, subIndex) => (
                                        <li key={subIndex} onClick={(e) => setSub(e, sub)}>
                                            <a style={{padding: "8px 5px"}}>{sub}</a>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                }
            </div>
        )
    }

    const comment = () => {
        return (
            <div className="memo">
                <div className="cate-top">
                    <h4 className="cate-title">검수 요청 내용</h4>
                </div>
                <input className="input-memo" type="text" id="name" name="comment" placeholder="검수 요청할 내용을 입력하세요." onChange={handleChange}/>
            </div>
        )
    }

    return (
        <div className="request">
            <div className="request-modal">
                <div className="request-top">
                    <h3 className='request-title'>검수요청</h3>
                    <button className="btn-close" onClick={()=>onClose()}>
                        <i className="icoKdc32 close"></i>
                    </button>
                </div>
                <div className="request-cnts">
                    {path()}
                    {title()}
                    {type()}
                    {sub()}
                    {comment()}
                </div>
                <button className="btn-request" onClick={onSubmit}>검수요청</button>
            </div>
        </div>
    )
}
export default RequestQA;